var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReadmore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 5,
    viewBox: "0 0 14 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.859375 2.07031L5.88281 4.07812C6.0651 4.15104 6.2526 4.22135 6.44531 4.28906C6.63802 4.35156 6.82292 4.38281 7 4.38281C7.17188 4.38281 7.35417 4.35156 7.54688 4.28906C7.73958 4.22135 7.92969 4.15104 8.11719 4.07812L13.125 2.07031C13.276 2.01302 13.3984 1.92188 13.4922 1.79688C13.5859 1.66667 13.6328 1.52865 13.6328 1.38281C13.6328 1.13281 13.5521 0.929688 13.3906 0.773438C13.2344 0.611979 13.0391 0.53125 12.8047 0.53125C12.6849 0.53125 12.5521 0.557292 12.4062 0.609375C12.2604 0.661458 12.1302 0.710938 12.0156 0.757812L6.5 2.95312H7.49219L1.96875 0.757812C1.85938 0.710938 1.73177 0.661458 1.58594 0.609375C1.4401 0.557292 1.30469 0.53125 1.17969 0.53125C0.950521 0.53125 0.755208 0.611979 0.59375 0.773438C0.432292 0.929688 0.351562 1.13281 0.351562 1.38281C0.351562 1.52865 0.398438 1.66667 0.492188 1.79688C0.585938 1.92188 0.708333 2.01302 0.859375 2.07031Z",
    fill: "#5D2E7A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadmore);
export default __webpack_public_path__ + "static/media/readmore.521174989899671e4482d40e27e0f1df.svg";
export { ForwardRef as ReactComponent };